import React, { Suspense } from 'react';
import Hero from '../components/Hero';
import Navbar from '../components/Navbar';

// Lazy-load non-critical sections to reduce initial bundle size
const AboutSection = React.lazy(() => import('../components/AboutSection'));
const FeatureSection = React.lazy(() => import('../components/FeatureSection'));
const Testimonials = React.lazy(() => import('../components/Testimonials'));
const FAQSection = React.lazy(() => import('../components/FAQSection'));
const CTA = React.lazy(() => import('../components/CTA'));
const Footer = React.lazy(() => import('../components/Footer'));
const WaitlistModal = React.lazy(() => import('../components/WaitlistModal'));

const LandingPage = () => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <>
      {/* Grain texture overlay */}
      <div className="grain-overlay" aria-hidden="true" />

      <main className="min-h-screen bg-salford-ivory font-body antialiased">
        <a
          href="#about"
          className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[200] focus:px-4 focus:py-2 focus:bg-salford-forest focus:text-salford-ivory font-mono text-sm"
        >
          Skip to main content
        </a>

        <Navbar onJoinWaitlist={() => setShowModal(true)} />
        <Hero onJoinWaitlist={() => setShowModal(true)} />

        <Suspense fallback={<div aria-hidden className="min-h-[120px]" /> }>
          <AboutSection />
        </Suspense>

        <Suspense fallback={<div aria-hidden className="min-h-[120px]" /> }>
          <FeatureSection />
        </Suspense>

        <Suspense fallback={<div aria-hidden className="min-h-[120px]" /> }>
          <Testimonials />
        </Suspense>

        <Suspense fallback={<div aria-hidden className="min-h-[120px]" /> }>
          <FAQSection />
        </Suspense>

        <Suspense fallback={<div aria-hidden className="min-h-[80px]" /> }>
          <CTA onJoinWaitlist={() => setShowModal(true)} />
        </Suspense>

        <Suspense fallback={<div aria-hidden className="h-24" /> }>
          <Footer />
        </Suspense>
      </main>

      <Suspense fallback={null}>
        <WaitlistModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        />
      </Suspense>
    </>
  );
};

export default LandingPage;
